import { render, staticRenderFns } from "./CardCorporateResponsibility.vue?vue&type=template&id=45c30a6e&scoped=true&"
import script from "./CardCorporateResponsibility.vue?vue&type=script&lang=js&"
export * from "./CardCorporateResponsibility.vue?vue&type=script&lang=js&"
import style0 from "./CardCorporateResponsibility.vue?vue&type=style&index=0&id=45c30a6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c30a6e",
  null
  
)

export default component.exports